




































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("login");

export default Vue.extend({
    name: "BasicInfoCell",
    props: {
        info: {
            type: Object,
            default: function() {
                return {};
            }
        },
        isForeign: {
            type: Boolean,
            default: false
        },
        orgConfig: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(["loggedIn"]),
        isNewUser() {
            return !this.info.identityNo;
        },
        showNationalityType(): boolean {
            if (Object.keys(this.orgConfig).length == 0) {
                return false;
            }
            return !!this.orgConfig["showNationalityType"];
        }
    },
    methods: {
        safeGo(path: string): string {
            return this.loggedIn ? path : "/login";
        }
    }
});
